import { FC } from 'react';
import { CurrentValues } from './CurrentValues/CurrentValues';
import { IressForm, IressStack, IressText } from '@iress-oss/ids-components';
import { CurrentPlanProjectionDetailsData, CurrentPlanProjectionDetailsProps } from '@xplan-pension-switching/common';
import { useCurrentPlanProjectionDetailsPageQuery, useReferenceDataQuery } from '../../services';
import { ProjectedGrowthRates } from './ProjectedGrowthRates/ProjectedGrowthRates';
import { OngoingContributions } from './OngoingContributions/OngoingContributions';
import { ProjectedValues } from './ProjectedValues/ProjectedValues';

export const CurrentPlanProjectionDetailsForm = IressForm<CurrentPlanProjectionDetailsData>;

export const CurrentPlanProjectionDetailsFormContent: FC<CurrentPlanProjectionDetailsProps> = props => {
    const { entityId, scenarioId, projectionId } = props;
    const { data } = useCurrentPlanProjectionDetailsPageQuery(entityId, scenarioId, projectionId);
    const { currentValues, ongoingContributions, projectedGrowthRates, projectedValues } =
        data.currentPlanProjectionDetailsPage.details;
    const refDataQueryResponse = useReferenceDataQuery();
    const referenceData = refDataQueryResponse.data.referenceData;

    return (
        <IressStack gutter="md">
            <IressText element="h2">{data.currentPlanProjectionDetailsPage.name}</IressText>
            <CurrentValues currentValues={currentValues} />
            <OngoingContributions ongoingContributions={ongoingContributions} />
            <ProjectedValues
                projectedValues={projectedValues}
                clientAge={data?.currentPlanProjectionDetailsPage?.owner?.age ?? 0}
                referenceData={referenceData}
            />
            <ProjectedGrowthRates projectedGrowthRates={projectedGrowthRates} referenceData={referenceData} />
        </IressStack>
    );
};
